import { RolePermissionType } from "../types/apiTypes";
import { useEffect } from "react";
import { useAppDispatch } from "./useReduxHooks";
import { setPermissions } from "../features/permissionsSlice";

export const useSetPermissions = (permissions?: RolePermissionType) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!permissions) return;

    const { view, export: exports, edit, share } = permissions;

    dispatch(
      setPermissions({
        isAllowedViewAccountPlans: view.account_plans.allowed,
        isAllowedViewPlaybooks: view.playbooks.allowed,
        isAllowedViewClientFullLeadInfo: view.client_lead_info.allowed,
        isAllowedViewINFUSELeadInfo: view.infuse_lead_info.allowed,

        isAllowedExportPlaybooks: exports.playbooks.allowed,
        isAllowedExportAccountPlans: exports.account_plans.allowed,
        isAllowedExportContactsAccountsList: exports.contacts_list.allowed,

        isAllowedEditCreateNewCampaign: edit.create_campaign.allowed,
        isAllowedEditResyncData: edit.resync_data.allowed,
        isAllowedEditActionsTargetTitles: edit.target_titles.allowed,
        isAllowedEditGenerateReports: edit.generate_reports.allowed,
        isAllowedEditLaunchAccountAnalysis:
          edit.launch_account_analysis.allowed,

        isAllowedShareAccess: share.access.allowed,
        isAllowedShareViewListInternalUsers: share.view_internal_users.allowed,

        isAllowedClientViewDemo: share.client_view_demo.allowed,
        isAllowedPermissionsManagement: share.permissions_management.allowed,
      }),
    );
  }, [permissions]);
};
